import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ReactSelectDropdown from "../../../common/DropdownMenus/ReactSelectDropdownWithSearch";
import { isEmptyArray, isEmptyVariable } from "../../../common/Global/commonFunctions";
import { CustomTableRow, DialogSaveButton, TableIcon } from "../../../common/Global/globalStyles.style";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import AlertDialog from "../../../common/AlertDialog";
import * as Constants from '../../../common/Global/constants';

const frameworkPlaceholderText = "Select Framework";
class AddFrameworkDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFrameworkObj:[],
            formErrors:{},
            frameworkArr:[],
            selectedFramework:frameworkPlaceholderText,
            isDrag:false,
        }
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showFramework) {
            this.setState({
                selectedFramework:frameworkPlaceholderText,
                selectedFrameworkObj:this.props.selectedFrameworkObj,
                isDrag:false,
            })
        }
    }
    
    frameworkDropdownClick = (item) => {
        let frameworkItem = [];
        if(Array.isArray(item)){
            frameworkItem = item;
        }else{
            frameworkItem.push(item);
        }
        let selectedFrameworkObj=[];
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['framework'] = "";
        }
        for(var i =0;i<frameworkItem.length;i++){
            // 1. Create a copy of the existing framework object
            let framework = {...frameworkItem[i]}; 

            // 2. Add the new 'frameworkOrderId' property to the copied object
            framework['frameworkOrderId'] = i + 1;
            selectedFrameworkObj.push(framework)
        }
        this.setState({
            selectedFrameworkObj:selectedFrameworkObj,
            formErrors:FormErrorsTemp
        })
    }

    handleSaveFramework = () => {
        let isError = false;
        let FormErrorsTemp = {};
        if(isEmptyArray(this.state.selectedFrameworkObj)){
            isError = true;
            FormErrorsTemp['framework'] = "Please select Framework";
        }
        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);
        }else{
            this.props.handleFrameworkDialogClose(true,this.state.selectedFrameworkObj)
        }
    }

    handleShowDeleteFrameworkAlertDialog = (frameworkOrderId) => {
        this.setState({
            showDeleteFrameworkAlertDialog:true,
            deleteFrameworkAlertDialogMessage:"Do you want to delete the Framework?",
            frameworkOrderId:frameworkOrderId
        })
    }

    handleDeleteFrameworkAlertDialogClose = () => {
        this.setState({
            showDeleteFrameworkAlertDialog:false,
            deleteFrameworkAlertDialogMessage:"",
            frameworkOrderId:""
        })
    }

    //delete timeline row
    handleDeleteFramework = (frameworkOrderIdToDelete) => {
        let tempRow = this.state.selectedFrameworkObj;
        tempRow.splice(frameworkOrderIdToDelete-1,1);

        // 1. Filter out the item to be deleted
        // We use filter instead of splice to ensure we're not mutating the state directly
        // before re-indexing. Also, frameworkOrderId is 1-based, not 0-based index.
        let updatedFrameworks = tempRow.filter(item => 
            item.frameworkOrderId !== frameworkOrderIdToDelete
        );

        // 2. Re-index and update the frameworkOrderId for the remaining items
        // Use map to create a new array with updated properties
        let reindexedFrameworks = updatedFrameworks.map((item, index) => {
            // Create a new object to avoid mutation
            return {
                ...item,
                frameworkOrderId: index + 1 // Re-assign order based on new index
            };
        });

        this.setState({
            selectedFrameworkObj:reindexedFrameworks,
            showDeleteFrameworkAlertDialog:false,
            deleteFrameworkAlertDialogMessage:""
        })
    }

    // Handle drag and drop reordering
    onDragEnd = (result) => {
        const { source, destination } = result;

        // Check if the item is dropped outside the droppable area
        if(!destination){
            return
        }

        // Check if the item is dropped in the same position
        if(destination.droppableId === source.droppableId &&
            destination.index === source.index){
            return
        }

        let newPosition = destination.index;
        let oldPosition = source.index;
        let selectedFrameworkObj = this.state.selectedFrameworkObj;

        // Reorder items locally
        let fieldObj = selectedFrameworkObj[oldPosition];
        selectedFrameworkObj.splice(oldPosition, 1)//remove from old position
        selectedFrameworkObj.splice(newPosition, 0, fieldObj);//move the field Obj to new pos

        // Update the order for all items
        let updatedFrameworkInfo = selectedFrameworkObj.map((item,idx)=>{
            item.frameworkOrderId = idx +1;
            return item;
        })

        this.setState({
            selectedFrameworkObj:updatedFrameworkInfo
        })
    };

    render() {
        return (
            <Modal
                className="custom-dialog"
                show={this.props.showFramework}
                backdrop="static"
            >
                <Modal.Header>
                    <h5>
                        {this.props.isEdit ? "Edit Framework" : "Add Framework"}
                    </h5>
                    <button
                        onClick={this.props.handleFrameworkDialogClose}
                        type="button"
                        data-dismiss="modal"
                    >
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div class="modal-body">
                    <div class="addnew-modal-form">
                        <div class="addnew-modal-form-group">
                            <p>Framework*</p>
                            <ReactSelectDropdown
                                handleReactSelectClose={this.frameworkDropdownClick}
                                selectedDDObj={this.state.selectedFrameworkObj}
                                selectDropdownArr={this.props.frameworkArr}
                                label={"frameworkName"}
                                value={"frameworkId"}
                                placeholder={this.state.selectedFramework}
                                isMultiselect={true}
                            />
                            {
                                !isEmptyVariable(this.state.formErrors['framework']) &&
                                <span class="cm-error">{this.state.formErrors['framework']}</span>
                            }
                        </div>
                    </div>
                    {!isEmptyArray(this.state.selectedFrameworkObj) &&
                    <div className="body-wrapper mt-2">
                        <div className="common-tab-bg">
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <div className="common-table" style={{width:"!00%",borderRadius:4}}>
                                    <div className="table-custom-layout">
                                        <div className="table-custom-header">
                                            <div className="table-custom-header-row">
                                                <p style={{width:"4%",justifyContent:"center", minHeight: "42px"}}>No.</p>
                                                <p style={{width:"80%"}}>Framework Name</p>
                                                <p style={{width:"4%"}}></p>
                                            </div>
                                        </div>
                                        <Droppable droppableId="droppable"
                                        //  isDropDisabled={!this.state.isDrag}
                                        >
                                            {(provided) => (
                                                <div className="table-custom-body"
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps} 
                                                >
                                                    {this.state.selectedFrameworkObj.map((item,index) => {
                                                        return(
                                                            <Draggable key={item.frameworkOrderId+""} draggableId={item.frameworkOrderId+""} index={index} 
                                                                // isDragDisabled={!this.state.isDrag}
                                                            >
                                                                {(provided,snapshot) => (
                                                                    <CustomTableRow
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        ref={provided.innerRef}
                                                                        isDragging={snapshot.isDragging}
                                                                        themeSettings={this.props.themeSettings}
                                                                        // isDragDisabled={!this.state.isDrag}
                                                                    >
                                                                        <p style={{width:"4%", justifyContent:"center"}}>{item.frameworkOrderId}</p>
                                                                        <p style={{width:"80%"}}>{item.frameworkName}</p>
                                                                        <p style={{width:"4%"}}>
                                                                            <TableIcon themeSettings={this.props.themeSettings} className="text-center"
                                                                                style={{marginLeft:10}}>
                                                                                    <a className="tool" data-title="Delete"
                                                                                    onClick={this.handleShowDeleteFrameworkAlertDialog.bind(this,item.frameworkOrderId)}>
                                                                                        <span
                                                                                            className="material-icons mx-2"
                                                                                            style={{fontSize: 18}}
                                                                                        >
                                                                                            remove_circle
                                                                                        </span>
                                                                                    </a>
                                                                            </TableIcon>
                                                                        </p>
                                                                    </CustomTableRow>
                                                                )}
                                                            </Draggable>
                                                        )
                                                    })}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </div>
                                </div>
                            </DragDropContext>
                        </div>
                    </div>
                    }
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.props.handleFrameworkDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton themeSettings={this.props.themeSettings} onClick={this.handleSaveFramework} type="button">Save</DialogSaveButton>
                        </div>
                    </div>
                </div>
                <AlertDialog
                    showAlertDialog={this.state.showDeleteFrameworkAlertDialog}
                    handleAlertDialogClose={this.handleDeleteFrameworkAlertDialogClose}
                    type= {Constants.ALERT_TYPE_WARNING}
                    alertDialogMessage={this.state.deleteFrameworkAlertDialogMessage}
                    proceedBtnClick={this.handleDeleteFramework.bind(this,this.state.frameworkOrderId)}
                    proceedBtnLabel={"Yes"}
                    themeSettings={this.props.themeSettings}
                />
            </Modal>
        )
    }
}
export default AddFrameworkDialog;
